import { useRecoilValue } from 'recoil';
import CoverableDetailsHeader from './components/CoverableDetailsHeader';
import CoverableDetailsInsuranceSums from './components/CoverableDetailsInsuranceSums';
import CoverableDetailsCoverableInformation from './components/CoverableDetailsCoverableInformation';
import CoverableDetailsYouHaveInformed from './components/CoverableDetailsYouHaveInformed';
import CoverableDetailsGeneralInformation from './components/CoverableDetailsGeneralInformation';
import CoverableDetailsConditionAndExclusions from './components/CoverableDetailsConditionsAndExclusions';
import { coverableDetailsAtom } from '../../recoil/atoms/coverableDetailsAtom';
import ImportantInformation from '../../shared_components/ImportantInformation/ImportantInformation';
import Coverages from '../../shared_components/Coverages/Coverages';
import CoverableDetailsWhoIsInsured from './components/CoverableDetailsWhoIsInsured';
import WizardPagetemplate from '../../templates/WizardPagetemplate';
import CoverableDetailsLimitedSums from './components/CoverableDetailsLimitedSums';
import CoverableDetailsMvpMilage from './components/CoverableDetailsMvpMilage';
import { type CarDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/mvp';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { Grid, GridItem } from '@flos/react-ui';

const CoverableDetailsPage: WizardPageComponent = () => {
    const { wizardNextStep, wizardPreviousStep } = useWizardNavigation();
    const coverableData = useRecoilValue(coverableDetailsAtom);
    return (
        <WizardPagetemplate
            hidePrevious
            hideNext
            onNext={wizardNextStep}
            onPrevious={wizardPreviousStep}
        >
            <Grid>
                <GridItem span={8} colStart={3}>
                    <div className="u-spacing-inset-l--squish-max@md u-spacing-inset-bottom-12 u-spacing-inset-bottom-none@xs">
                        <CoverableDetailsHeader wizardPreviousStep={wizardPreviousStep} />
                        {coverableData ? (
                            <div>
                                <div className={'u-display-none u-display-block@xs'}>
                                    <h2> {coverableData?.flavourName}</h2>
                                    <p className={'paragraph--large'}> {coverableData?.name} </p>
                                </div>
                                <ImportantInformation coverable={coverableData} shouldRenderPrice />
                                {coverableData.flavourName !== 'Bilforsikring' && (
                                    <CoverableDetailsWhoIsInsured coverable={coverableData} />
                                )}
                                <Coverages
                                    coverages={coverableData.coverages}
                                    showCoverableDetailsUI={true}
                                    flavourName={coverableData.flavourName}
                                    coverableId={coverableData.fixedId}
                                />
                                <CoverableDetailsInsuranceSums coverable={coverableData} />
                                <CoverableDetailsLimitedSums coverable={coverableData} />
                                <CoverableDetailsCoverableInformation coverable={coverableData} />
                                {coverableData.flavourName === 'Bilforsikring' && (
                                    <>
                                        <CoverableDetailsWhoIsInsured coverable={coverableData} />
                                        <CoverableDetailsMvpMilage
                                            carCoverable={coverableData as CarDTO}
                                        />
                                    </>
                                )}
                                <CoverableDetailsYouHaveInformed coverable={coverableData} />
                                <CoverableDetailsGeneralInformation />
                                <CoverableDetailsConditionAndExclusions coverable={coverableData} />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </GridItem>
            </Grid>
        </WizardPagetemplate>
    );
};

export default CoverableDetailsPage;
